import styled from 'astroturf/react'

import Marker from './marker'
import _MutualAvailabilitySignUpWrapper from "styles-MutualAvailabilitySignUpWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=MutualAvailabilitySignUpWrapper";
import _TimeButtonWrapper from "styles-TimeButtonWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=TimeButtonWrapper";
import _TimeButtonStyledMarker from "styles-TimeButtonStyledMarker.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=TimeButtonStyledMarker";
import _TimeButtonTimeDisplay from "styles-TimeButtonTimeDisplay.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=TimeButtonTimeDisplay";
import _ThumbsUpIcon from "styles-ThumbsUpIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=ThumbsUpIcon";
import _InviteeCountDisplay from "styles-InviteeCountDisplay.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=InviteeCountDisplay";
import _InviteeCounter from "styles-InviteeCounter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/styles.js?styleId=InviteeCounter";


const transitionTime = '300ms'
const lineHeight = '14px'

export const MutualAvailabilitySignUpWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "MutualAvailabilitySignUpWrapper",
  styles: _MutualAvailabilitySignUpWrapper
})

export const TimeButtonWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "TimeButtonWrapper",
  styles: _TimeButtonWrapper
})

export const TimeButtonStyledMarker = /*#__PURE__*/styled(Marker, null, {
  displayName: "TimeButtonStyledMarker",
  styles: _TimeButtonStyledMarker
})

export const TimeButtonTimeDisplay = /*#__PURE__*/styled('div', null, {
  displayName: "TimeButtonTimeDisplay",
  styles: _TimeButtonTimeDisplay
})

export const ThumbsUpIcon = /*#__PURE__*/styled('img', null, {
  displayName: "ThumbsUpIcon",
  styles: _ThumbsUpIcon,
  attrs: props => ({
    ...props,
    'data-component': 'invitee-count-icon',
    alt: ''
  })
})

export const InviteeCountDisplay = /*#__PURE__*/styled('div', null, {
  displayName: "InviteeCountDisplay",
  styles: _InviteeCountDisplay
})

export const InviteeCounter = /*#__PURE__*/styled('div', null, {
  displayName: "InviteeCounter",
  styles: _InviteeCounter
})
